module.exports = __webpack_public_path__ + "img/dark.89096bb2.svg";